import { create } from 'zustand';

/** Tracks video resources until the browser can draw their first frame. */
const useVideoFrameLoadingStore = create<{ pending: Map<string, symbol> }>(() => ({ pending: new Map() }));

/** A stale load must not clear the latest load of the same resource. */
export function beginVideoFrameLoading(key: string): () => void {
  const token = Symbol(key);
  useVideoFrameLoadingStore.setState(({ pending }) => ({ pending: new Map(pending).set(key, token) }));
  return () => {
    useVideoFrameLoadingStore.setState(({ pending }) => {
      if (pending.get(key) !== token) return { pending };
      const next = new Map(pending);
      next.delete(key);
      return { pending: next };
    });
  };
}

export function resetVideoFrameLoading(): void {
  useVideoFrameLoadingStore.setState({ pending: new Map() });
}

export function useIsVideoFrameLoading(key: string | undefined): boolean {
  return useVideoFrameLoadingStore((state) => key !== undefined && state.pending.has(key));
}
